import { HTMLAttributes } from 'react';
import { MdOutlineHelpOutline } from 'react-icons/md';
import { Heading, Text, Tooltip } from 'components';
import { FontSize, FontWeight } from 'commons';
import * as S from './styles';

export enum CARD_STATUS {
  DEFAULT = 'default',
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
}

interface BigNumberCardProps extends HTMLAttributes<HTMLDivElement> {
  icon: JSX.Element;
  title: string;
  tooltipText: string;
  status?: CARD_STATUS;
  isCurrency?: boolean;
}

export function BigNumberCard({
  icon,
  title,
  tooltipText,
  status = CARD_STATUS.DEFAULT,
  isCurrency,
  children,
}: BigNumberCardProps) {
  return (
    <S.Card>
      <S.IconWrapper>{icon}</S.IconWrapper>

      <S.DescriptionWrapper>
        <S.Description>
          <Text>{title}</Text>

          <Tooltip message={tooltipText}>
            <div className="icon">
              <MdOutlineHelpOutline />
            </div>
          </Tooltip>
        </S.Description>

        <S.ValueWrapper $status={status}>
          {isCurrency && (
            <Text size={FontSize.font16} weight={FontWeight.bold}>
              R$
            </Text>
          )}

          <Heading size={FontSize.font24} weight={FontWeight.bold}>
            {children}
          </Heading>
        </S.ValueWrapper>
      </S.DescriptionWrapper>
    </S.Card>
  );
}
